import { render, staticRenderFns } from "./ModalAdminCustomerClassroomAdd.vue?vue&type=template&id=666c3a00&scoped=true&lang=pug&"
import script from "./ModalAdminCustomerClassroomAdd.vue?vue&type=script&lang=ts&"
export * from "./ModalAdminCustomerClassroomAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAdminCustomerClassroomAdd.vue?vue&type=style&index=0&id=666c3a00&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c3a00",
  null
  
)

export default component.exports